const FA_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] as const

/** Convert Latin digits (0-9) in a string/number to Persian digits (۰-۹). */
export function toPersianDigits(input: string | number): string {
  return String(input).replace(/[0-9]/g, (d) => FA_DIGITS[Number(d)])
}

/** Convert Persian digits (۰-۹) in a string back to Latin digits (0-9). */
export function toLatinDigits(input: string): string {
  return input.replace(/[۰-۹]/g, (d) => String(FA_DIGITS.indexOf(d as (typeof FA_DIGITS)[number])))
}

/**
 * Group a number with thousands separators, using Persian digits for `fa`.
 *
 * Grouping is pinned to `en-US` and the digits are swapped afterwards, rather
 * than formatting with `fa-IR`. That means Persian keeps a LATIN comma rather
 * than the Persian thousands separator (U+066C) — deliberately. This mirrors
 * the reference implementation these pages are being migrated from
 * (`lib/i18n/format.ts` in the netbaan-frontend-next project), and both apps
 * have to render the same figure the same way while they run side by side.
 *
 * Do not "fix" this to `fa-IR` without changing it there first.
 */
export function formatNumber(value: number, lang: string | undefined): string {
  const grouped = new Intl.NumberFormat('en-US').format(value)
  return lang === 'fa' ? toPersianDigits(grouped) : grouped
}
